import { BaseService } from './base.service';
import { Product, ProductQuery, ProductsResponse } from '@/types/product.types';

class ProductsService extends BaseService {
  constructor() {
    super('/products');
  }

  async getProducts(query: ProductQuery = {}): Promise<ProductsResponse> {
    const params: Record<string, string | number> = {};
    if (query.locationId) params.locationId = query.locationId;
    if (typeof query.limit === 'number') params.limit = query.limit;
    if (typeof query.offset === 'number') params.offset = query.offset;
    const search = query.search?.trim();
    if (search) params.search = search;
    if (query.collection) params.collection = query.collection;
    return this.get<ProductsResponse>('', { params });
  }

  async getProductById(id: string): Promise<Product> {
    return this.get<Product>(`/${id}`);
  }
}

export default new ProductsService();
